(function () {
  'use strict';

  var BRL = null;
  function fmtBRL(cents) {
    if (BRL === null) {
      try {
        BRL = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
        });
      } catch (e) {
        BRL = false;
      }
    }
    var value = cents / 100;
    if (BRL) return BRL.format(value);
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function parseQty(value) {
    if (!value) return 0;
    var cleaned = String(value)
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/unidades?/g, '')
      .replace(/\bun\b/g, '')
      .replace(/un$/g, '')
      .replace(/\+/g, '')
      .replace(/kit/g, '')
      .replace(/pcs?/g, '');
    var match = cleaned.match(/(\d+)/);
    if (!match) return 0;
    var n = parseInt(match[1], 10);
    return isNaN(n) ? 0 : n;
  }

  function readData(root) {
    var script = root.querySelector('script[data-tvp-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateCard(root, variantId, fallbackPriceCents, fallbackOptionValue) {
    var data = readData(root);
    var info = null;
    if (data && data.variants && variantId != null) {
      info = data.variants[String(variantId)] || null;
    }

    var priceCents = info ? info.price : fallbackPriceCents;
    var optionValue = info ? info.optionValue : fallbackOptionValue;

    if (priceCents == null) return;

    var qty = parseQty(optionValue);
    var totalEl = root.querySelector('[data-tvp-total]');
    var qtyEl = root.querySelector('[data-tvp-qty]');
    var unitEl = root.querySelector('[data-tvp-unit]');

    if (totalEl) totalEl.textContent = fmtBRL(priceCents);

    if (qty > 0) {
      root.classList.remove('tiger-volume-pack--no-qty');
      if (qtyEl) qtyEl.textContent = qty;
      if (unitEl) {
        var unitCents = Math.round(priceCents / qty);
        unitEl.textContent = fmtBRL(unitCents);
      }
    } else {
      root.classList.add('tiger-volume-pack--no-qty');
      if (qtyEl) qtyEl.textContent = '—';
    }
  }

  function forceQtyOne(sectionId) {
    var input = document.getElementById('Quantity-' + sectionId);
    if (input && input.value !== '1') {
      input.value = '1';
    }
  }

  function init() {
    var cards = document.querySelectorAll('[data-tiger-volume]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var sectionId = card.getAttribute('data-section-id');
      forceQtyOne(sectionId);
    });

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object') {
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant) return;
      var card = document.getElementById('Tiger-Volume-Pack-' + data.sectionId);
      if (!card) return;
      var optionIndex = parseInt(card.getAttribute('data-option-index'), 10);
      var optionValue = null;
      if (!isNaN(optionIndex) && optionIndex >= 0 && data.variant.options) {
        optionValue = data.variant.options[optionIndex];
      }
      updateCard(card, data.variant.id, data.variant.price, optionValue);
      forceQtyOne(data.sectionId);
    });

    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      cards.forEach(function (card) {
        forceQtyOne(card.getAttribute('data-section-id'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
